export default "__VITE_ASSET__BxNqunjS__"